import * as THREE from 'three'
import Box from './Box'
import Frame from './Frame'
import Size from './Size'

export default class Generator {
  public createBox3d(frame: Frame, box: Box): THREE.Object3D {
    // NOTE クランプを配置しやすいように、boxのpositionは初期(0,0,0)としておく。
    // Geometry(形状)とMaterial(表面素材)から、Mesh(物体)を作る。
    const group = new THREE.Group()
    const scale = frame.scale

    // 天板
    if (box.face.top) {
      const size = new Size(box.outer.x, box.thick.top, box.outer.z)
      const board = new THREE.Mesh(
        new THREE.BoxGeometry(size.x * scale, size.y * scale, size.z * scale),
        new THREE.MeshPhongMaterial({ map: frame.texture })
      ).translateY((box.outer.y / 2 - box.thick.top / 2) * scale)
      board.castShadow = true
      group.add(board)
    }

    // 底板
    if (box.face.bottom) {
      const size = new Size(box.outer.x, box.thick.bottom, box.outer.z)
      const board = new THREE.Mesh(
        new THREE.BoxGeometry(size.x * scale, size.y * scale, size.z * scale),
        new THREE.MeshPhongMaterial({ map: frame.texture })
      ).translateY((box.outer.y / 2 - box.thick.bottom / 2) * -1 * scale)
      board.castShadow = true
      group.add(board)
    }

    // 側板
    if (box.face.side) {
      // 右(X面手前)
      {
        const size = new Size(box.thick.side, box.outer.y, box.outer.z)
        const board = new THREE.Mesh(
          new THREE.BoxGeometry(size.x * scale, size.y * scale, size.z * scale),
          new THREE.MeshPhongMaterial({ map: frame.texture })
        ).translateX((box.outer.x / 2 - box.thick.side / 2) * scale)
        board.castShadow = true
        group.add(board)
      }
      // 左(X面奥)
      {
        const size = new Size(box.thick.side, box.outer.y, box.outer.z)
        const board = new THREE.Mesh(
          new THREE.BoxGeometry(size.x * scale, size.y * scale, size.z * scale),
          new THREE.MeshPhongMaterial({ map: frame.texture })
        ).translateX((box.outer.x / 2 - box.thick.side / 2) * -1 * scale)
        board.castShadow = true
        group.add(board)
      }
      // 前(Z面手前)
      {
        const size = new Size(box.outer.x, box.outer.y, box.thick.side)
        const board = new THREE.Mesh(
          new THREE.BoxGeometry(size.x * scale, size.y * scale, size.z * scale),
          new THREE.MeshPhongMaterial({ map: frame.texture })
        ).translateZ((box.outer.z / 2 - box.thick.side / 2) * scale)
        board.castShadow = true
        group.add(board)
      }
      // 後(Z面奥)
      {
        const size = new Size(box.outer.x, box.outer.y, box.thick.side)
        const board = new THREE.Mesh(
          new THREE.BoxGeometry(size.x * scale, size.y * scale, size.z * scale),
          new THREE.MeshPhongMaterial({ map: frame.texture })
        ).translateZ((box.outer.z / 2 - box.thick.side / 2) * -1 * scale)
        board.castShadow = true
        group.add(board)
      }
    }
    return group
  }

  public createBoxWireFrame(frame: Frame, box: Box): THREE.LineSegments {
    const geometry = new THREE.BoxGeometry(
      box.outer.x * frame.scale,
      box.outer.y * frame.scale,
      box.outer.z * frame.scale
    )
    const edge = new THREE.EdgesGeometry(geometry, 0.1)
    const wireFrame = new THREE.LineSegments(edge, new THREE.LineBasicMaterial({ color: 0xc8c8c8 }))
    return wireFrame
  }

  public createGround(): THREE.Mesh {
    const ground = new THREE.Mesh(
      new THREE.PlaneGeometry(1000, 1000, 10, 10),
      new THREE.MeshPhongMaterial({ color: 0xffffff })
    )
    ground.rotation.x = Math.PI / -2
    ground.receiveShadow = true
    return ground
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Generator.ts